// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (hover: hover) {\nbutton:hover svg[data-v-74c32719] {\n      -webkit-filter: drop-shadow(0 0 1px #ffffff);\n      filter: drop-shadow(0 0 1px #ffffff);\n      --tw-scale-x: 1.1;\n      --tw-scale-y: 1.1;\n}\n}\n", ""]);
// Exports
module.exports = exports;
